//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'

export default {

    name: 'ProfileKeyFacts',

    mixins: [ProfileData],

    props: {
        company: {
        },
        destination: {
        },
    },

    data() {
        return {
        }
    },

    /*async fetch() {

        const response = await this.$axios.$get(this.$ziggy.route('api.profile.destination.images', {company: this.company.id}))
        this.images = response.data
    }*/

}

